import menus from './menus.js';
import agentManagement from './agentManagement.js';
import gpuReplacement from './gpuReplacement.js';

import customerLookup from './customerLookup.js';

export default {
    ...agentManagement,
    ...menus,
    ...customerLookup,
    ...gpuReplacement,
};
